const changeRange = (from, to) => ({
  type: 'CHANGE_RANGE',
  from,
  to,
});

export default changeRange;
